import {Component, OnInit, Input, Output, EventEmitter, SimpleChanges, SimpleChange, ViewChild, ElementRef} from '@angular/core';
import CommonUtils from '../../shared/common.util';
import {CatalogService} from '../catalog-api/catalog.service';
import {AssetService} from '../../shared/asset.service';
import {UserService} from '../../user/user.service';
import {DPUserService, DPSubscriptionService} from '../../portalv1';
import {CatalogManageService} from './catalog-manage.service';
import {ToasterService} from 'angular2-toaster';
import {UserDetailsService} from '../../shared/user.details.service';
import {InAppNotificationsService} from '../../notifications/notifications.service';
import {ApiConstants} from '../../shared';
import {DPTitleBatchRequest} from '../../portalv1/model/dp-title-batch-request';
import {GeneralConstants} from '../../shared/general.constants';
import {QAService} from '../qa/qa.service';
import {TitleRequestsService} from '../title-requests/title-requests.service';
import {get, difference} from 'lodash';
import {DatahealthService} from '../datahealth/datahealth.service';
import moment = require('moment');
import {JwtHelper} from 'angular2-jwt';

declare var jQuery: any;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'catalog-manage',
    templateUrl: 'catalog-manage.component.html',
    styleUrls: ['catalog-manage.service.scss']
})
export class CatalogManageComponent implements OnInit {
    @ViewChild('modal', {read: ElementRef}) modal: ElementRef;
    @Input() selectedShow;
    originalData;
    dataLoaded = false;
    @Output() selectedShowChange = new EventEmitter();
    tabs = ['Overview', 'Meta Data', 'BoxOffice Data', 'Casts', 'Crews', 'Awards', 'Data Mapping', 'Images', 'Scheduling', 'Trailers', 'External Mappings', 'Verification'];
    showTabs = ['Overview', 'Meta Data', 'Genres', 'Casts', 'Crews', 'Awards', 'Data Mapping', 'Images', 'Scheduling', 'Trailers', 'External Mappings', 'Verification'];
    sportsTabs = ['Overview', 'Meta Data', 'Data Mapping', 'Images', 'Scheduling', 'Trailers', 'External Mappings', 'Verification'];
    talentTabs = ['Overview', 'Meta Data', 'Genres', 'Work Credits', 'Awards', 'Data Mapping', 'Images', 'Scheduling', 'Trailers', 'External Mappings', 'Verification'];
    selectedTab = this.tabs[0];
    editMode = false;
    updatingchanges = false;
    updatedGenes = [];
    updatedNotes: any = {};
    catalogStates = ['demand_generation', 'data_collection', 'requested', 'harvested', 'metadata_ready'];
    dataStates = ['cust_ready', 'onboarded'];
    releaseTypes = ['network', 'digital_original', 'digital_original_film'];
    mpaaContentRatings = ['G', 'PG', 'PG-13', 'R', 'NC-17', 'NR', 'UR'];
    releaseStrategies = ['THEATRICAL', 'DAY_AND_DATE', 'HOME_ENTERTAINMENT'];
    releaseStrategiesTypes = ['THEATRICAL_WIDE', 'THEATRICAL_LIMITED', 'THEATRICAL_IMAX', 'DAY_AND_DATE', 'HOME_ENTERTAINMENT'];
     releaseStrategyMap = new Map()
        .set('THEATRICAL_WIDE', 'Release Strategy - Theatrical; Release Type - Wide')
        .set('THEATRICAL_LIMITED', 'Release Strategy - Theatrical; Release Type - Limited')
        .set('THEATRICAL_IMAX', 'Release Strategy - Theatrical; Release Type - Imax')
        .set('DAY_AND_DATE', 'Release Strategy - Day And Date; Release Type - Unknown')
        .set('HOME_ENTERTAINMENT', 'Release Strategy - Home Entertainment; Release Type - Unknown');
    isExternalUser = true;
    isHelpdeskAdmin = false;
    canEditMetadata = false;
    showComponent = false;
    editLoading = false;
    imdbChanged = [];
    importLoading = false;
    harvestedQARequest;
    rejectMessage = '';
    rejectModalLoading = false;
    genres = null;
    languages = null;
    languagesValues = null;
    countries = null;
    countriesValues = null;
    titlesToAdd = [];
    checkinLoading = false;
    checkInInfo: any;
    occupationTags = [];
    showTextarea: boolean = false;
    userInputText: string = '';

    private jwtHelper = new JwtHelper();
    selectedRole: string = 'All';
    selectedCrewRole: string = 'All';
    selectedWorkCreditRole: string = 'All';
    selectedWorkCreditContentType: string = 'All';

    constructor(private catalogService: CatalogService,
                public assetService: AssetService,
                private userService: UserService,
                private userDetailsService: UserDetailsService,
                private dpUserService: DPUserService,
                private catalogManageService: CatalogManageService,
                private notificationService: InAppNotificationsService,
                private toasterService: ToasterService,
                private apiConstants: ApiConstants,
                private generalConstants: GeneralConstants,
                private dpSubscriptionsService: DPSubscriptionService,
                private titleRequestsService: TitleRequestsService,
                private datahealthService: DatahealthService,
                private qaService: QAService) {
    }

    ngOnInit(): void {
        if (localStorage.getItem('is_data_api_user') === 'true') {
            this.isExternalUser = false;
            this.dpUserService.getOwnUser().then(user => {
                if (
                    user.roles &&
                    user.roles.findIndex(x => x === 'Helpdesk Admin') > -1
                ) {
                    this.isHelpdeskAdmin = true;
                }
            });
        }

        // console.log(this.selectedShow);
        this.genres = Object.keys(this.apiConstants.GENRES) || [];
        this.languages = this.apiConstants.LANGUAGES.map(item => item.name);
        this.languagesValues = this.apiConstants.LANGUAGES.map(item => item.code);
        this.countries = this.apiConstants.COUNTRIES.map(item => item.displayName);
        this.countriesValues = this.apiConstants.COUNTRIES.map(item => item.iso);
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnChanges(changes: SimpleChanges) {
        this.titlesToAdd = [];
        this.selectedTab = this.tabs[0];
        // If we have changed the selected show, get the metadata.
        if (changes.selectedShow) {
            const selectedShow: SimpleChange = changes.selectedShow;
            if (selectedShow.currentValue) {
                if (!selectedShow.previousValue || !selectedShow.previousValue.parrot_id || (selectedShow.previousValue.parrot_id !== selectedShow.currentValue.parrot_id)) {
                    if (selectedShow.currentValue.catalog_state) {
                        this.getLastChecked();
                        // If there is a catalog state, that means it is available in the catalog api
                        this.dataLoaded = false;
                        this.editMode = false;
                        this.showDetails(selectedShow.currentValue);
                        // For a title with harvested state, we should load in the harvested QA entry
                        if (selectedShow.currentValue.catalog_state === 'harvested') {
                            this.catalogManageService.getHarvestedQARequest(selectedShow.currentValue.parrot_id)
                                .then((res) => {
                                    if (!res.harvestedQA[0]) {
                                        this.toasterService.pop('info', 'No harvested QA request found for current title. Please contact an administrator.');
                                    }
                                    this.harvestedQARequest = res.harvestedQA[0];
                                })
                                .catch((err) => {
                                    console.error('Failed to get harvested QA request for current title: ' + err.toString());
                                    this.toasterService.pop('error', 'Failed to get harvested QA request for current title!');
                                });
                        }
                        // If the title is requested or harvested, any user should be able to edit it.
                        if (['harvested', 'requested'].includes(selectedShow.currentValue.catalog_state) || this.isHelpdeskAdmin || this.userDetailsService.isMappingApprover()) {
                            this.canEditMetadata = true;
                        } else {
                            this.canEditMetadata = false;
                        }
                    } else {
                        this.hideDetails();
                    }
                }
            }
        }
    }

    isLoading(): boolean {
        return this.editLoading || this.rejectModalLoading || this.importLoading;
    }

    updateDataChange(propKey, parentKey?) {
        this.updatingchanges = true;
        let genomeObj;
        if (parentKey) {
            if (this.selectedShow.metadata.data[parentKey][propKey] !== this.originalData.metadata.data[parentKey][propKey]) {
                genomeObj = this.getGenomeObj(propKey, this.selectedShow.metadata.data[parentKey][propKey]);
            }
        } else {
            if (this.selectedShow.metadata.data[propKey] !== this.originalData.metadata.data[propKey]) {
                genomeObj = this.getGenomeObj(propKey, this.selectedShow.metadata.data[propKey]);
            }
        }
        if (genomeObj) {
            this.updatedGenes.forEach((element, index) => {
                if (element.gene === genomeObj.gene) {
                    this.updatedGenes.splice(index, 1);
                }
            });
            this.updatedGenes.push(genomeObj);
        }
        this.updatingchanges = false;
    }

    clearDate(parentKey, key) {
        if (parentKey) {
            this.selectedShow.metadata[parentKey][key] = '';
        } else {
            this.selectedShow.metadata[key] = '';
        }
        this.updateChange(key, parentKey);
    }

    updateChange(propKey, parentKey?) {
        this.updatingchanges = true;
        let genomeObj;
        if (parentKey) {
            if (this.selectedShow.metadata[parentKey][propKey] !== this.originalData.metadata[parentKey][propKey]) {
                genomeObj = this.getGenomeObj(propKey, this.selectedShow.metadata[parentKey][propKey]);
            }
        } else {
            if (this.selectedShow.metadata[propKey] !== this.originalData.metadata[propKey]) {
                genomeObj = this.getGenomeObj(propKey, this.selectedShow.metadata[propKey]);
            }
        }
        if (genomeObj) {
            this.updatedGenes.forEach((element, index) => {
                if (element.gene === genomeObj.gene) {
                    this.updatedGenes.splice(index, 1);
                }
            });
            this.updatedGenes.push(genomeObj);
        }
        this.updatingchanges = false;
    }

    getGenomeObj(propKey, propValue) {
        const genomeObj: any = {};
        genomeObj.parrot_id = this.selectedShow.parrot_id;
        genomeObj.title = this.selectedShow.title;
        genomeObj.gene = propKey;
        genomeObj.value = propValue;
        genomeObj.source = 'manual';
        return genomeObj;
    }

    updateNotes() {
        // This function is not used.
        if (this.selectedShow.metadata.data.notes !== this.originalData.metadata.data.notes) {
            this.updatedNotes = {};
            this.updatedNotes.parrot_id = this.selectedShow.parrot_id;
            this.updatedNotes.author = this.userService.currentUser.first_name + ' ' + this.userService.currentUser.last_name;
            this.updatedNotes.content = this.selectedShow.metadata.data.notes;
            this.updatedNotes.type = 'comment';

            if (this.originalData.metadata.data.notes && this.originalData.metadata.data.notes.id) {
                this.updatedNotes.operation = 'update';
            } else if (this.selectedShow.metadata.data.notes) {
                this.updatedNotes.operation = 'add';
            }
        }
    }

    addNote() {
        const value = jQuery('#new-note-content').val();
        if (value === '') {
            alert('content is empty');
            return;
        }
        const note: any = {};
        note.parrot_id = this.selectedShow.parrot_id;
        note.author = this.userService.currentUser.first_name + ' ' + this.userService.currentUser.last_name;
        note.content = value;
        note.type = 'comment';
        note.content_type = this.selectedShow.content_type;
        const notesPayload = {'notes': [note]};
        this.catalogService.updateNotes(notesPayload, 'add').then(res => {
            this.showDetails(this.selectedShow);
        }).catch(error => {
        });
    }

    deleteNote(noteToDeleted) {
        const note: any = {};
        note.parrot_id = this.selectedShow.parrot_id;
        note.id = noteToDeleted.id;
        note.content_type = this.selectedShow.content_type;
        const notesPayload = {'notes': [note]};
        this.catalogService.updateNotes(notesPayload, 'delete').then(res => {
            this.showDetails(this.selectedShow);
        }).catch(error => {
        });
    }

    saveChanges() {
        if (this.updatingchanges) {
            setTimeout(() => {
                this.saveChanges();
            }, 100);
            return;
        }
        this.validateGenes(this.updatedGenes);
        if (this.updatedGenes.length > 0) {
            // Check special case of title gene as this needs to go to a separate endpoint
            this.updatedGenes = this.updatedGenes.map(item => {
                item.title = this.originalData.metadata['title'];
                return item;
            });
            const titleGene = this.updatedGenes.find(item => item.gene === 'title');
            // this.updatedGenes = this.updatedGenes.filter(item => item.gene !== 'title');

            this.dataLoaded = false;
            const genomePayload = {'updateGenesList': this.updatedGenes};
            this.catalogService.updateGenomeDeprecated(genomePayload, this.originalData.content_type).then(res => {
                // if (titleGene) {
                //   this.catalogService.putTitleNameChange(titleGene.parrot_id, titleGene.title, titleGene.value)
                //     .then(res => {
                //       this.updatedGenes = [];
                //       this.enableEditMode(false);
                //       if (!this.updatedNotes.operation) {
                //         this.showDetails(this.selectedShow);
                //       }
                //     })
                //     .catch((error => {
                //       this.dataLoaded = true;
                //     }));
                // }
                // else {
                this.updatedGenes = [];
                this.enableEditMode(false);
                if (!this.updatedNotes.operation) {
                    this.showDetails(this.selectedShow);
                }
                // }
            }).catch(error => {
                this.dataLoaded = true;
            });
        }

        if (this.updatedNotes.operation) {
            const notesPayload = {'notes': [this.updatedNotes]};
            this.catalogService.updateNotes(notesPayload).then(res => {
                this.updatedNotes = {};
                this.showDetails(this.selectedShow);
            }).catch(error => {
            });
        }
    }

    validateGenes(genes) {
        try {
        genes.forEach((element, index) => {
            // Remove empty or duplicate entries from an array or allow null entries if they are part of
            // the allowed empty genes
            if (element.value || this.generalConstants.getAllowedEmptyGenes().includes(element.gene)) {
                if (Array.isArray(element.value)) {
                    // Replace commas as they will make multiple entries
                    element.value = element.value.map(item => {
                        if (item) {
                            // tslint:disable-next-line:no-unused-expression
                            item.replace(',', ' ') || '' ;
                            return item;
                        }
                    });
                    const copyArr = [];
                    element.value.forEach((val, valIndex) => {
                        if (val !== '' && element.value.indexOf(val) === valIndex) {
                            copyArr.push(val);
                        }
                    });

                    // Since the API takes in a comma separated list and we want to convert it
                    element.value = copyArr.join();
                    if (element.value.length <= 0 && element.value !== '') {
                        genes.splice(index, 1);
                    }
                }
            } else {
                genes.splice(index, 1);
            }
        });
        } catch (ex) {
            console.log(ex);
            this.toasterService.pop('error', 'Duplicate Item Found or Null Item present!');
        }
    }

    addToUpdatedGenes(gene, value) {
        const genomeObject = this.getGenomeObj(gene, value);
        // Check if the gene already exists in updated genes and replace it
        this.updatedGenes.forEach((element, index) => {
            if (element.gene === genomeObject.gene) {
                this.updatedGenes.splice(index, 1);
            }
        });
        this.updatedGenes.push(genomeObject);
    }

    addToList(list, key, value, gene) {
        // Validate that the value can be added
        if (value === '') {
            // Generally the value will not be empty
            // Genre tags must start on an empty string however.
            return;
        }
        if (list && list.indexOf(value) !== -1) {
            this.toasterService.pop('error', 'Item already present!');
            return;
        }

        let updatedList = list && list.slice();
        if (!updatedList) {
            // Create the array if it doesn't exist
            updatedList = [value];
        } else {
            updatedList.push(value);
        }
        this.updateMetadata(key, updatedList, gene);
    }

    removeFromList(list, key, value, gene) {
        const updatedList = list && list.slice().filter(item => item !== value);
        this.updateMetadata(key, updatedList, gene);
    }

    updateMetadata(key, value, gene) {
        const keys = key.split('.');
        let currentObject = this.selectedShow;
        for (const currentKey of keys) {
            if (currentObject && (currentKey === keys[keys.length - 1] || currentObject.hasOwnProperty(currentKey))) {
                // If the current key is the last key, do not set the current object to it.
                if (currentKey !== keys[keys.length - 1]) {
                    currentObject = currentObject[currentKey];
                }
            } else {
                currentObject = null;
            }
        }

        // If current object is null, the key does not exist.
        if (currentObject) {
            // Don't throw errors for same value, but don't emit changes either.
            if (currentObject[keys[keys.length - 1]] !== value) {
                // Update value, emit the change and add to the genes update object
                currentObject[keys[keys.length - 1]] = value;
                this.selectedShowChange.emit(this.selectedShow);
                this.addToUpdatedGenes(gene, value);
            } else if (gene === 'occupation') {
                currentObject[keys[keys.length - 1]] = value;
                this.selectedShowChange.emit(this.selectedShow);
                this.addToUpdatedGenes(gene, value);
            }else if (gene === 'production_company') {
                currentObject[keys[keys.length - 1]] = value;
                this.selectedShowChange.emit(this.selectedShow);
                this.addToUpdatedGenes(gene, value);
            }else if (gene === 'distribution_company') {
                currentObject[keys[keys.length - 1]] = value;
                this.selectedShowChange.emit(this.selectedShow);
                this.addToUpdatedGenes(gene, value);
            }else if (gene === 'others') {
                currentObject[keys[keys.length - 1]] = value;
                this.selectedShowChange.emit(this.selectedShow);
                this.addToUpdatedGenes(gene, value);
            }else if (gene === 'universes') {
                currentObject[keys[keys.length - 1]] = value;
                this.selectedShowChange.emit(this.selectedShow);
                this.addToUpdatedGenes(gene, value);
            }else if (gene === 'characters') {
                currentObject[keys[keys.length - 1]] = value;
                this.selectedShowChange.emit(this.selectedShow);
                this.addToUpdatedGenes(gene, value);
            }

        } else {
            console.error(`Selected show either does not have ${key} key for ${gene} gene`);
            this.toasterService.pop('error', `Selected show either does not have ${key} key for ${gene} gene`);
        }
    }

    updateCatalogState(state) {
        this.selectedShow.metadata.catalog_state = state;
        this.selectedShowChange.emit(this.selectedShow);
        this.updateChange('catalog_state');
    }

    updateDataState(state) {
        this.selectedShow.metadata.internal_data.data_state = state;
        this.selectedShowChange.emit(this.selectedShow);
        this.updateChange('data_state', 'internal_data');
    }

    updateReleaseType(type) {
        this.selectedShow.metadata.data.release_type = type;
        this.selectedShowChange.emit(this.selectedShow);
        this.updateChange('release_type', 'data');
    }

    showDetails(show) {
        this.showComponent = true;
        this.selectedShow = show;
        this.selectedShowChange.emit(this.selectedShow);
        this.dataLoaded = false;
        this.getMetaData(show);
    }

    async getMetaData(show) {

        const queryString = {
            'query': {
                'bool': {
                    'must': [
                        {
                            'term': {
                                'parrot_id.keyword': show.parrot_id
                            }
                        }
                    ]
                }
            }
        };


        const seriesGenresRawQueryString = {
            'query': {
                'bool': {
                    'must': [
                        {
                            'term': {
                                'parrot_id': {
                                    'value': show.parrot_id
                                }
                            }
                        }
                    ]
                }
            },
            '_source': [
                'parrot_id',
                'data.genres',
                'data.genres_raw'
            ]
        };

        const query = JSON.stringify(queryString);
        const seriesGenresRawQuery = JSON.stringify(seriesGenresRawQueryString);

        try {
            const resInternalData = await this.catalogService.callEsProxyCustomQueryNewMetadata(query, 'helpdesk_internal_data');
            const res = await this.catalogService.getCatalogMetadata(show.parrot_id, show.content_type);
            const creditsResponse = await this.catalogService.getCredits(show.parrot_id, show.content_type.toUpperCase());
            this.dataLoaded = true;
            show.metadata = res.metadata[0];
            show.metadata.data.also_known_as = get(show, 'metadata.data.also_known_as', []);
            show.metadata.verification_status = get(show, 'metadata.verification_status.status');
            show.metadata.data.genre_tags = get(show, 'metadata.data.genre_tags', []);
            show.metadata.data.estimated_start_date = get(show, 'metadata.data.estimated_start_date', undefined);

            if (show.content_type !== 'movie') {
                const seriesGenresRawMetadata = await this.catalogService.callEsProxyLoadMetaData(seriesGenresRawQuery, 'series_metadata');
                this.getGenresRaw(show, seriesGenresRawMetadata);
                show.metadata.data.original_country = CommonUtils.getObjectValuesArray(get(show, 'metadata.data.original_country'));
                show.metadata.data.original_network = CommonUtils.getObjectValuesArray(get(show, 'metadata.data.original_network'));
                show.metadata.data.original_language = CommonUtils.getObjectValuesArray(get(show, 'metadata.data.original_language'));
            } else {
                show.metadata.data.original_country = this.getOrderedItems(get(show, 'metadata.data.original_country', []));
                show.metadata.data.original_language = this.getOrderedItems(get(show, 'metadata.data.original_language', []));
                show.metadata.data.production_company = this.getOrderedItems(get(show, 'metadata.data.production_company', []));
                show.metadata.data.distribution_company = this.getOrderedItems(get(show, 'metadata.data.distribution_company', []));
                show.metadata.data.content_ratings = this.getUSContentRatings(get(show, 'metadata.data.content_ratings', []));
                show.metadata.data.opening_weekend_theatre_count = this.getUCANOpeningWeekendTheatreCount(get(show, 'metadata.data.box_office_data', []));
                show.metadata.data.release_info = this.getPrimaryReleaseType(get(show, 'metadata.data.release_info', []));
                if (show.metadata.data.franchises) {

                    show.metadata.data.franchises.others = get(show, 'metadata.data.franchises.others', []);
                    show.metadata.data.franchises.characters = get(show, 'metadata.data.franchises.characters', []);
                    show.metadata.data.franchises.universes = get(show, 'metadata.data.franchises.universes', []);
                } else {
                    show.metadata.data.franchises = {};
                    show.metadata.data.franchises.others = [];
                    show.metadata.data.franchises.characters = [];
                    show.metadata.data.franchises.universes = [];

                }
                show.metadata.data.ip_data = get(show, 'metadata.data.ip_data', undefined);
                show.metadata.data.runtime_in_minutes = get(show, 'metadata.data.runtime_in_minutes', undefined);
                show.metadata.data.production_budget = this.getProductionBudget(get(show, 'metadata.data.production_budget', undefined));
            }
            if (show.contentType !== 'sports') {
                show.metadata.data.sports = get(show, 'metadata.data.sports', undefined);
            }
            show.metadata.data.mood = get(show, 'metadata.data.mood', []);
            show.metadata.data.status = get(show, 'metadata.data.status', []);
            this.getCredits(show, creditsResponse, show.content_type.toUpperCase());
            if (show.metadata.data.status.length > 0) {
                let statusValue = show.metadata.data.status;
                statusValue = statusValue.toLowerCase();
                statusValue = statusValue.replace('_', ' ').split(' ');
                let transformed = statusValue.map((word: string) => {
                    return word[0].toUpperCase() + word.substring(1);
                }).join(' ');
                if (show.content_type === 'movie') {
                    transformed = transformed.replace(' ', '_');
                }
                show.metadata.data.status = transformed;
            }
            show.metadata.data.setting = get(show, 'metadata.data.setting', []);
            show.metadata.data.time_period = get(show, 'metadata.data.time_period', []);
            show.metadata.data.theme = get(show, 'metadata.data.theme', []);
            show.metadata.data.character = get(show, 'metadata.data.character', []);
            show.metadata.data.subject = get(show, 'metadata.data.subject', []);
            show.metadata.data.release_type = get(show, 'metadata.data.release_type', this.releaseTypes[0]);

            if (show.content_type === 'talent') {
                show.metadata.data.occupation = get(show, 'metadata.data.occupation', []);
                this.occupationTags = get(show, 'metadata.data.occupation', []);
            }

            try {
                const val = resInternalData.hits.hits[0]._source;

                if (val) {
                    show.metadata.internal = val.internal_data ? val.internal_data : {};
                    show.metadata.internal_data = val.internal_data ? val.internal_data : {};
                    if (val.internal_data) {
                        show.metadata.internal.notes = val.internal_data.notes ? val.internal_data.notes : [];
                    }
                }
            } catch (ex) {
                console.log(ex);
                show.metadata.internal = {};
                show.metadata.internal.notes = [];
            }

            show.metadata.data.external_mappings.imdb_id = get(show, 'metadata.data.external_mappings.imdb_id');
            show.metadata.data.external_mappings.wikibase_id = get(show, 'metadata.data.external_mappings.wikibase_id');
            show.metadata.data.external_mappings.wiki_id = get(show, 'metadata.data.external_mappings.wiki_id');
            show.metadata.data.external_mappings.tmdb_id = get(show, 'metadata.data.external_mappings.tmdb_id');
            show.metadata.data.external_mappings.tvdb_id = get(show, 'metadata.data.external_mappings.tvdb_id');
            show.metadata.data.external_mappings.justwatch_id = get(show, 'metadata.data.external_mappings.justwatch_id');
            if (show.content_type === 'sports') {
                show.metadata.data.external_mappings.sports_db_id = get(show, 'metadata.data.external_mappings.sports_db_id');
            }

            show.metadata.data.tv_series_type = get(show, 'metadata.data.tv_series_type');

            show.metadata.data.content_sub_type = get(show, 'metadata.data.content_sub_type');
            show.metadata.data.game = get(show, 'metadata.data.game');
            show.metadata.data.environment = get(show, 'metadata.data.environment');
            show.metadata.data.participation = get(show, 'metadata.data.participation');
            show.metadata.data.game_type = get(show, 'metadata.data.game_type');
            show.metadata.data.skill_set = get(show, 'metadata.data.skill_set');
            show.metadata.data.event_frequency = get(show, 'metadata.data.event_frequency');

            show.metadata.chartImage = this.assetService.getShowImageUrl(show.parrot_id);
            show.metadata.posterImage = this.assetService.getShowPosterImageUrl(show.parrot_id);
            show.metadata.bannerImage = this.assetService.getShowBannerImageUrl(show.parrot_id);

            this.originalData = jQuery.extend(true, {}, this.selectedShow);
            this.selectedShowChange.emit(this.selectedShow);
        } catch (error) {
            this.dataLoaded = true;
            // this.errorHandler(error);
        }
        ;
    }

    addNewProperty(obj) {
        if (!obj) {
            obj = {1: ''};
            return;
        }
        obj[Object.keys(obj).length + 1] = '';
    }

    deleteProperty(obj, property) {
        delete obj[property];
    }

    getLenth(obj) {
        if (!obj) {
            return 0;
        }
        return Object.keys(obj).length;
    }

    getKeys(obj) {
        if (!obj) {
            obj = {};
        }
        return Object.keys(obj);
    }

    selectTab(tab) {
        this.selectedTab = tab;
    }

    async enableEditMode(flag) {
        this.editLoading = true;
        this.imdbChanged = [];
        // If we are enabling edit mode, check if the title has been claimed
        if (flag) {
            if (this.selectedShow.catalog_state === 'requested') {
                const isClaimed = await this.catalogManageService.isClaimed(this.selectedShow);
                try {
                    if (isClaimed && isClaimed !== this.generalConstants.getNotClaimedUser() && isClaimed !== this.userDetailsService.getCachedUserName()) {
                        this.toasterService.pop('info', 'This title is already being edited by someone');
                        this.editLoading = false;
                    } else {
                        // Set claimed by to this user
                        this.catalogManageService.setClaimed(this.selectedShow.parrot_id, this.userDetailsService.getCachedUserName(), this.selectedShow.content_type)
                            .then((res) => {
                                this.editMode = flag;
                                this.editLoading = false;
                            })
                            .catch((err) => {
                                console.error('Failed to update internal data claimed by gene: ' + err.toString());
                                this.toasterService.pop('error', 'Failed to update internal data claimed by gene!');
                                this.editLoading = false;
                            });
                    }
                } catch (err) {
                    console.error('Failed to call ES to check if the title is claimed: ' + err.toString());
                    this.toasterService.pop('error', 'Failed to call ES to check if the title is claimed!');
                    this.editLoading = false;
                }
            } else {
                this.editMode = flag;
                this.editLoading = false;
            }
        } else {
            // Disabling edit mode, save the changes to the selected show object.
            this.selectedShow = jQuery.extend(true, {}, this.originalData);
            this.selectedShowChange.emit(this.selectedShow);
            if (this.selectedShow.catalog_state === 'requested') {
                // Remove the claim
                try {
                    await this.catalogManageService.setClaimed(this.selectedShow.parrot_id, this.generalConstants.getNotClaimedUser(), this.selectedShow.content_type);
                } catch (err) {
                    console.error('Failed to update internal data claimed by gene: ' + err.toString());
                    this.toasterService.pop('error', 'Failed to update internal data claimed by gene!');
                }
            }
            this.editMode = flag;
            this.editLoading = false;
        }
    }

    async handleLoadDataMappings() {
        this.importLoading = true;

        let imdbId = get(this.selectedShow, 'metadata.data.external_mappings.imdb_id');
        let wikiId = get(this.selectedShow, 'metadata.data.external_mappings.wiki_id');
        let wikibaseId = get(this.selectedShow, 'metadata.data.external_mappings.wikibase_id');
        let tmdbId = get(this.selectedShow, 'metadata.data.external_mappings.tmdb_id');
        let justwatchId = get(this.selectedShow, 'metadata.data.external_mappings.justwatch_id');
        const parrotId = get(this.selectedShow, 'metadata.parrot_id');
        const title = get(this.selectedShow, 'metadata.title');
        const catalogState = get(this.selectedShow, 'metadata.catalog_state');
        const type = get(this.selectedShow, 'metadata.data.type');

        ({imdbId, wikibaseId, wikiId, tmdbId, justwatchId} = await this.doMappingDatasources(imdbId, wikibaseId, wikiId, tmdbId, justwatchId));

        if (!imdbId && !wikiId && !wikibaseId && !tmdbId && ! justwatchId) {
            this.toasterService.pop('warn', 'Please provide imdb id, wiki page id or wikibase id');
            return;
        }
        this.importLoading = true;

        try {
            const result = await this.titleRequestsService.fetchMetadataFromEnrich(imdbId, wikibaseId, wikiId, tmdbId, justwatchId, parrotId, catalogState, type, title);
            if (!result) {
                this.importLoading = false;
                this.toasterService.pop('info', 'Metadata is not found');
                return;
            }

            const dsMappingWikipedia = get(result, 'metadata.data.datasource_mappings.wikipedia', []);
            if (dsMappingWikipedia.length > 0) {
                const contentType = this.selectedShow.content_type ? this.selectedShow.content_type : this.selectedShow.contentType;
                const dsMappingCreationCalls = dsMappingWikipedia.map(wikiLink => {
                    const selectedMapping = {
                        title_id: this.selectedShow.parrot_id,
                        title: this.selectedShow.title,
                        mapping_type: 'LINK',
                        mapping_value: wikiLink,
                        source: 'wikipedia',
                        content_type: contentType,
                        requestUser: this.userDetailsService.getCachedUserName()
                    };
                    // @ts-ignore
                    return this.datahealthService.createMapping('wikipedia', selectedMapping);
                });
                await Promise.all(dsMappingCreationCalls);
                this.toasterService.pop('info', 'Data mappings loaded succesfully');
            } else {
                this.toasterService.pop('info', 'Data mappings are not found');
            }
        } catch (err) {
            console.error('Failed to import metadata: ' + err.toString());
            this.toasterService.pop('error', 'Failed to import metadata');
            this.importLoading = false;
        } finally {
            this.importLoading = false;
        }
    }

    async handleImportMetadata() {
        let imdbId = get(this.selectedShow, 'metadata.data.external_mappings.imdb_id');
        let wikiId = get(this.selectedShow, 'metadata.data.external_mappings.wiki_id');
        let wikibaseId = get(this.selectedShow, 'metadata.data.external_mappings.wikibase_id');
        let tmdbId = get(this.selectedShow, 'metadata.data.external_mappings.tmdb_id');
        let justwatchId = get(this.selectedShow, 'metadata.data.external_mappings.justwatch_id');
        const parrotId = get(this.selectedShow, 'metadata.parrot_id');
        const catalogState = get(this.selectedShow, 'metadata.catalog_state');
        const type = get(this.selectedShow, 'metadata.data.type', 'Show');
        const title = get(this.selectedShow, 'metadata.title');

        ({imdbId, wikibaseId, wikiId, tmdbId, justwatchId} = await this.doMappingDatasources(imdbId, wikibaseId, wikiId, tmdbId, justwatchId));

        if (!imdbId && !wikiId && !wikibaseId && !tmdbId && ! justwatchId) {
            this.toasterService.pop('warn', 'Please provide imdb id, wiki page id or wikibase id');
            return;
        }
        this.importLoading = true;

        try {
            const result = await this.titleRequestsService.fetchMetadataFromEnrich(imdbId, wikibaseId, wikiId, tmdbId, justwatchId, parrotId, catalogState, type, title);
            if (!result) {
                this.importLoading = false;
                this.toasterService.pop('info', 'Metadata is not found');
                return;
            }
            const newAkas = get(result, 'metadata.data.also_known_as', []);
            const existAkas = get(this.selectedShow, ' metadata.data.also_known_as', []);
            if (newAkas && newAkas.length > 0) {
                let akas = difference(newAkas, existAkas);
                if (akas.length > 0) {
                    akas = existAkas.concat(akas);
                    this.imdbChanged.push('akas');
                    this.updateMetadata('metadata.data.also_known_as', akas, 'also_known_as');
                }
            }

            const newLongDescription = get(result, 'metadata.data.long_description');
            const existLongDescription = !get(this.selectedShow, 'metadata.data.long_description');
            if (newLongDescription) {
                this.imdbChanged.push('long_description');
                this.updateMetadata('metadata.data.long_description', newLongDescription, 'long_description');
            }

            const newShortDescription = get(result, 'metadata.data.short_description', this.getFirstSentence(newLongDescription));
            if (newShortDescription) {
                this.imdbChanged.push('short_description');
                this.updateMetadata('metadata.data.short_description', newShortDescription, 'short_description');
            }

            let newMainGenre = get(result, 'metadata.data.main_genre');
            const existMainGenre = get(result, 'metadata.data.main_genre');
            if (newMainGenre && !existMainGenre) {
                newMainGenre = newMainGenre.map(item => item.toLowerCase()).filter(item => this.genres.includes(item));
                if (newMainGenre.length > 0) {
                    this.imdbChanged.push('main_genre');
                    this.updateMetadata('metadata.data.main_genre', newMainGenre[0], 'main_genre');
                }
            }
            const newGenreTags = get(result, 'metadata.data.genre_tags', []);
            const existGenreTags = get(this.selectedShow, 'metadata.data.genre_tags', []);
            if (newGenreTags && newGenreTags.length > 0) {
                let genreTags = newGenreTags.map(item => item.toLowerCase()).filter(item => this.apiConstants.GENRE_TAGS.includes(item));
                genreTags = difference(newGenreTags, existGenreTags);
                if (genreTags.length > 0) {
                    genreTags = existGenreTags.concat(genreTags);
                    this.imdbChanged.push('genre_tags');
                    this.updateMetadata('metadata.data.genre_tags', genreTags, 'genre_tags');
                }
            }

            const newOriginalNetwork = get(result, 'metadata.data.original_network.0');
            const existingOriginalNetwork = get(this.selectedShow, 'metadata.data.original_network.0');
            if (newOriginalNetwork) {
                this.imdbChanged.push('original_network');
                this.updateMetadata('metadata.data.original_network', [newOriginalNetwork], 'original_network');
            }

            if (this.selectedShow.content_type !== 'movie') {
                const newOriginalLanguage = get(result, 'metadata.data.original_language.0');
                const existOriginalLanguage = get(this.selectedShow, 'metadata.data.original_language.0');
                if (newOriginalLanguage) {
                    this.imdbChanged.push('original_language');
                    this.updateMetadata('metadata.data.original_language', [newOriginalLanguage], 'original_language');
                }

                const newOriginalCountry = get(result, 'metadata.data.original_country.0');
                const existOriginalCountry = get(this.selectedShow, 'metadata.data.original_country.0');
                if (newOriginalCountry) {
                    this.imdbChanged.push('original_country');
                    this.updateMetadata('metadata.data.original_country', [newOriginalCountry], 'original_country');
                }
            }else {

                const newOriginalLanguage = this.getOrderedItems(get(result, 'metadata.data.original_language' , []));
                const existOriginalLanguage = get(this.selectedShow, 'metadata.data.original_language' , []);
                if (newOriginalLanguage && newOriginalLanguage.length > 0) {
                    let languages = difference(newOriginalLanguage, existOriginalLanguage);
                    if (languages.length > 0) {
                        languages = existOriginalLanguage.concat(languages);
                        this.imdbChanged.push('original_language');
                        this.updateMetadata('metadata.data.original_language', languages, 'original_language');
                    }
                }

                const newOriginalCountry = this.getOrderedItems(get(result, 'metadata.data.original_country' , []));
                const existOriginalCountry = get(this.selectedShow, 'metadata.data.original_country' , []);
                if (newOriginalCountry && newOriginalCountry.length > 0) {
                    let countries = difference(newOriginalCountry, existOriginalCountry);
                    if (countries.length > 0) {
                        countries = existOriginalCountry.concat(countries);
                        this.imdbChanged.push('original_country');
                        this.updateMetadata('metadata.data.original_country', countries, 'original_country');
                    }
                }

                const newProductionCompany = this.getOrderedItems(get(result, 'metadata.data.production_company' , []));
                const existProductionCompany = get(this.selectedShow, 'metadata.data.production_company' , []);
                if (newProductionCompany && newProductionCompany.length > 0) {
                    let productionCompanies = difference(newProductionCompany, existProductionCompany);
                    if (productionCompanies.length > 0) {
                        productionCompanies = existProductionCompany.concat(productionCompanies);
                        this.imdbChanged.push('production_company');
                        this.updateMetadata('metadata.data.production_company', productionCompanies, 'production_company');
                    }
                }

                const newDistributionCompany = this.getOrderedItems(get(result, 'metadata.data.distribution_company' , []));
                const existDistributionCompany = get(this.selectedShow, 'metadata.data.distribution_company' , []);
                if (newDistributionCompany && newDistributionCompany.length > 0) {
                    let distributionCompanies = difference(newDistributionCompany, existDistributionCompany);
                    if (distributionCompanies.length > 0) {
                        distributionCompanies = existDistributionCompany.concat(distributionCompanies);
                        this.imdbChanged.push('distribution_company');
                        this.updateMetadata('metadata.data.distribution_company', distributionCompanies, 'distribution_company');
                    }
                }

            }
            const newReleaseYear = get(result, 'metadata.data.release_year');
            const existReleaseYear = get(this.selectedShow, ' metadata.data.release_year');
            if (newReleaseYear) {
                this.imdbChanged.push('release_year');
                this.updateMetadata('metadata.data.release_year', newReleaseYear, 'release_year');
            }

            const newStartDate = type.toLowerCase() === 'talent' ? get(result, 'metadata.data.dob') : get(result, 'metadata.data.start_date');
            const existStartDate = get(this.selectedShow, ' metadata.data.start_date');
            if (newStartDate && !existStartDate) {
                this.imdbChanged.push('start_date');
                this.updateMetadata('metadata.data.start_date', newStartDate, 'start_date');
            }

            const newEndDate = get(result, 'metadata.data.end_date');
            const existEndDate = get(this.selectedShow, ' metadata.data.end_date');
            if (newEndDate && !existEndDate) {
                this.imdbChanged.push('end_date');
                this.updateMetadata('metadata.data.end_date', newEndDate, 'end_date');
            }

            const newTotalEpisodes = get(result, 'metadata.data.total_episodes');
            const existTotalEpisodes = get(this.selectedShow, ' metadata.data.total_episodes');
            if (newTotalEpisodes && !existTotalEpisodes) {
                this.imdbChanged.push('total_episodes');
                this.updateMetadata('metadata.data.total_episodes', newTotalEpisodes, 'total_episodes');
            }

            const newTotalSeasons = get(result, 'metadata.data.total_seasons');
            const existTotalSeasons = get(this.selectedShow, ' metadata.data.total_seasons');
            if (newTotalSeasons && !existTotalSeasons) {
                this.imdbChanged.push('total_seasons');
                this.updateMetadata('metadata.data.total_seasons', existTotalSeasons, 'total_seasons');
            }

            this.selectedShowChange.emit(this.selectedShow);
            this.toasterService.pop('info', 'Successfully refresh metadata!');
            this.importLoading = false;
        } catch (err) {
            console.error('Failed to import metadata: ' + err.toString());
            this.toasterService.pop('error', 'Failed to import metadata');
            this.importLoading = false;
        }
        ;

    }

    private async doMappingDatasources(imdbId: string, wikibaseId: string, wikiId: string, tmdbId: string, justwatchId: string) {
        const dsMappings = await this.titleRequestsService.getDatasourceMapping(this.selectedShow.parrot_id);
        if (dsMappings && dsMappings.length > 0) {
            const dsMapping = dsMappings[0];
            const newImdbId = dsMappings[0].imdb_id;
            const newWikibaseId = dsMappings[0].wikibase_id;
            const newWikiId = dsMappings[0].wiki_id;
            const newTmdbId = dsMappings[0].tmdb_id;
            const newJustwatchId = dsMappings[0].justwatch_id;

            if (newImdbId && !imdbId) {
                imdbId = newImdbId;
                this.updateMetadata('metadata.data.external_mappings.imdb_id', imdbId, 'imdb_id');
            }
            if (newWikibaseId && !wikibaseId) {
                wikibaseId = newWikibaseId;
                this.updateMetadata('metadata.data.external_mappings.wikibase_id', wikibaseId, 'wikibase_id');
            }
            if (newWikiId && !wikiId) {
                wikiId = newWikiId;
                this.updateMetadata('metadata.data.external_mappings.wiki_id', wikiId, 'wiki_id');
            }
            if (newTmdbId && !tmdbId) {
                tmdbId = newTmdbId;
                this.updateMetadata('metadata.data.external_mappings.tmdb_id', tmdbId, 'tmdb_id');
            }
            if (newJustwatchId && !justwatchId) {
                justwatchId = newJustwatchId;
                this.updateMetadata('metadata.data.external_mappings.justwatch_id', justwatchId, 'justwatch_id');
            }
        }
        return {imdbId, wikibaseId, wikiId, tmdbId, justwatchId};
    }

    getFirstSentence(text) {
        if (text) {
            return text.substring(0, text.indexOf('.') !== -1 ? text.indexOf('.') : text.length);
        }
        return text;
    }

    handleRequestQA() {
        this.editLoading = true;
        const parrotId = this.selectedShow.parrot_id;

        Promise.all([
            this.catalogManageService.createHarvestedQARequest(
                parrotId, this.userDetailsService.getUsername()
            ),
            this.catalogService.updateGenome([parrotId], ['catalog_state'], ['harvested'], this.selectedShow.content_type),
            this.catalogService.createYoutubeSearchTerm(parrotId, this.selectedShow.content_type)
        ])
            .then((res) => {
                this.selectedShow.catalog_state = 'harvested';
                this.toasterService.pop('success', 'Successfully submitted title for QA');
                this.showDetails(this.selectedShow);

                if (this.selectedShow.catalog_state === 'harvested') {
                    this.catalogManageService.getHarvestedQARequest(this.selectedShow.parrot_id)
                        .then((harvestedRes) => {
                            if (!harvestedRes.harvestedQA[0]) {
                                this.toasterService.pop('info', 'No harvested QA request found for current title. Please contact an administrator.');
                            }
                            this.harvestedQARequest = harvestedRes.harvestedQA[0];
                        })
                        .catch((err) => {
                            console.error('Failed to get harvested QA request for current title: ' + err.toString());
                            this.toasterService.pop('error', 'Failed to get harvested QA request for current title!');
                        });
                }

                this.editLoading = false;
            })
            .catch((err) => {
                console.error('Failed to request QA: ' + err.toString());
                this.toasterService.pop('error', 'Failed to request QA!');
                this.editLoading = false;
            });
    }

    handleHarvestedQA(action: 'approve' | 'reject') {
        if (action === 'approve') {
            this.editLoading = true;
            this.catalogManageService.updateHarvestedQARequest(this.harvestedQARequest.id, this.userDetailsService.getUsername(), 'APPROVED', this.selectedShow.content_type)
                .then((res) => {
                    // Check that the response is valid then move to internal account
                    if (res.message === 'Successfully approved harvested title QA request') {
                        const update = this.catalogService.updateGenome([this.selectedShow.parrot_id], ['catalog_state'], ['demand_generation'], this.selectedShow.content_type);
                        this.selectedShow.catalog_state = 'demand_generation';
                        this.harvestedQARequest = undefined;
                        const titlesList: DPTitleBatchRequest = {
                            titles: [this.selectedShow.parrot_id]
                        };
                        this.showDetails(this.selectedShow);
                        this.dpSubscriptionsService.addTitleBatch(titlesList, this.generalConstants.getInternalAccountId())
                            // tslint:disable-next-line:no-shadowed-variable
                            .then((res) => {
                                this.editLoading = false;
                                this.toasterService.pop('success', 'Successfully approved harvested QA request!');
                            })
                            .catch((err) => {
                                // Check if it is an error for subscription already exists
                                let errorJSON = undefined;
                                if (err._body) {
                                    errorJSON = JSON.parse(err._body);
                                }
                                if (errorJSON && errorJSON.error && errorJSON.error.message &&
                                    errorJSON.error.message === this.generalConstants.getSubscriptionAlreadyExistsMessage()) {
                                    // The request did not go through because the subscription already exists. Still a success.
                                    this.editLoading = false;
                                    this.toasterService.pop('warning', errorJSON.error.message);
                                } else {
                                    // Error handling
                                    this.editLoading = false;
                                    this.toasterService.pop('error', errorJSON.error.message);
                                }
                            });
                    } else {
                        // The response was not correct.
                        console.error('Failed to correctly update the harvested QA request: ' + JSON.stringify(res));
                        this.toasterService.pop('error', 'Failed to correctly updated the harvested QA request!');
                        this.editLoading = false;
                    }
                })
                .catch((err) => {
                    console.error('Failed to approve harvested QA request: ' + err.toString());
                    this.toasterService.pop('error', 'Failed to approve harvested QA request!');
                    this.editLoading = false;
                });
        } else if (action === 'reject') {
            // Open up the modal to let the user enter a rejection message
            this.modal.nativeElement.style.display = 'block';
        }
    }

    closeAndRejectModal() {
        this.rejectModalLoading = true;
        Promise.all([
            this.catalogManageService.updateHarvestedQARequest(this.harvestedQARequest.id, this.userDetailsService.getUsername(), 'REJECTED', this.selectedShow.content_type),
            this.notificationService.postNotification(
                this.harvestedQARequest.request_user,
                this.userDetailsService.getUsername(),
                `${this.selectedShow.metadata.display_name} was rejected in harvesting QA`,
                this.rejectMessage
            )
        ])
            .then((res) => {
                this.rejectMessage = '';
                this.selectedShow.catalog_state = 'requested';
                this.harvestedQARequest = undefined;
                this.rejectModalLoading = false;
                this.toasterService.pop('success', 'Successfully rejected harvested QA request!');
                this.closeModal();
            })
            .catch((err) => {
                console.error('Failed to reject harvested QA request: ' + err.toString());
                this.toasterService.pop('error', 'Failed to reject harvested QA request!');
                this.rejectModalLoading = false;
                this.closeModal();
            });
    }

    closeModal() {
        this.modal.nativeElement.style.display = 'none';
    }

    hideDetails() {
        this.showComponent = false;
    }

    handleAddToCustomerReady() {
        const metadata = this.selectedShow.metadata;
        this.titlesToAdd = [
            {
                parrotId: metadata.parrot_id,
                title: metadata.title,
                genreTags: metadata.data.genre_tags,
                originalLanguage: metadata.data.original_language && metadata.data.original_language[0],
                originalCountry: metadata.data.original_country && metadata.data.original_country[0],
                originalNetwork: metadata.data.original_network && metadata.data.original_network[0],
                releaseYear: metadata.data.release_year,
                totalSeasons: metadata.data.total_seasons,
                totalEpisodes: metadata.data.total_episodes,
                shortDescription: metadata.data.short_description,
                contentType: metadata.data.type
            }
        ];
    }

    clickCheckIn() {
        this.checkinLoading = true;
        this.qaService.updateQARequest(this.selectedShow.parrot_id, this.userDetailsService.getCachedUserName(), 'mappings')
            .then(res => {
                this.getLastChecked();
                this.showDetails(this.selectedShow);
                this.checkinLoading = false;
            })
            .catch(error => {
                const errorJSON = JSON.parse(error._body);
                this.toasterService.pop('error', errorJSON.error.message || 'Error verifying');
                this.checkinLoading = false;
            });
    }

    getLastChecked() {
        this.checkInInfo = undefined;
        this.qaService.getLastCompletedQARequest(this.selectedShow.parrot_id, 'mappings', this.selectedShow.content_type)
            .then(res => {
                if (res !== null && res.qa_requests) {
                    if (res.qa_requests.length === 1) {
                        this.checkInInfo = res.qa_requests[0];
                    }
                }
            })
            .catch(error => {
                const errorJSON = JSON.parse(error._body);
                this.toasterService.pop('error', errorJSON.error.message || 'Error verifying');
            });
    }

    handleMsDate(ms: number) {
        if (ms !== undefined) {
            const date = new Date(ms);
            return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
        } else {
            return '';
        }
    }

    isValidDate(datestr: string) {
        return CommonUtils.isValidDate(datestr);
    }

    displayDate(item) {
        try {
            const date = moment(item, 'YYYY-MM-DD', true);
            return date.isValid() ? date.format('DD-MM-YYYY') : item;
        } catch (err) {
            return item;
        }
    }

    viewInfo(contentType: string, source: string, mapping_value: string, sports_sub_content_type?: string) {

        if (mapping_value) {
            if (source === 'imdb_id') {
                if (contentType === 'talent' || contentType === 'Talent') {
                    const newWindow = window.open('https://www.imdb.com/name/' + mapping_value);
                } else {
                    const newWindow = window.open('https://www.imdb.com/title/' + mapping_value);
                }
            } else if (source === 'wiki_id') {
                const newWindow = window.open('https://en.wikipedia.org/wiki?curid=' + mapping_value);
            } else if (source === 'wikibase_id') {
                const newWindow = window.open('https://www.wikidata.org/wiki/' + mapping_value);
            } else if (source === 'tvdb_id') {
                const newWindow = window.open('https://thetvdb.com/search?query=' + mapping_value);
            } else if (source === 'tmdb_id') {
                if (contentType === 'talent' || contentType === 'Talent') {
                    const newWindow = window.open('https://www.themoviedb.org/person/' + mapping_value);
                } else  if (contentType === 'movie' || contentType === 'Movie') {
                    const newWindow = window.open('https://www.themoviedb.org/movie/' + mapping_value);
                } else {
                    const newWindow = window.open('https://www.themoviedb.org/tv/' + mapping_value);
                }
            } else if (source === 'justwatch_id') {
                const newWindow = window.open('https://www.justwatch.com/');
            } else if (source === 'the_numbers_id') {
                if (contentType === 'talent' || contentType === 'Talent') {
                    const newWindow = window.open('https://www.the-numbers.com/person/' + mapping_value);
                } else  if (contentType === 'movie' || contentType === 'Movie') {
                    const newWindow = window.open('https://www.the-numbers.com/movie/' + mapping_value);
                } else {
                    const newWindow = window.open('https://www.the-numbers.com');
                }
            } else if (source === 'sports_db_id') {
                if (sports_sub_content_type === 'Sports Team') {
                    const newWindow = window.open('https://www.thesportsdb.com/team/' + mapping_value);
                } else if (sports_sub_content_type === 'Competition') {
                    const newWindow = window.open('https://www.thesportsdb.com/league/' + mapping_value);
                } else {
                    const newWindow = window.open('https://www.thesportsdb.com/');
                }
            } else if (source === 'futon_critic_id') {
                const newWindow = window.open('http://www.thefutoncritic.com/showatch/' + mapping_value);
            } else if (source === 'iqiyi_id') {
                const newWindow = window.open('https://www.iq.com/play/' + mapping_value);
            } else if (source === 'my_drama_list_id') {
                if (contentType === 'talent' || contentType === 'Talent') {
                    const newWindow = window.open('https://mydramalist.com/people/' + mapping_value);
                } else {
                    const newWindow = window.open('https://mydramalist.com/' + mapping_value);
                }

            } else if (source === 'prime_wire_id') {
                if (contentType === 'movie' || contentType === 'Movie') {
                    const newWindow = window.open('https://primewire.id/movie/' + mapping_value);
                } else {
                    const newWindow = window.open('https://primewire.id/series/' + mapping_value);
                }
            } else if (source === 'reel_good_id') {
                const newWindow = window.open('https://reelgood.com/');
            } else if (source === 'share_tv_id') {
                const newWindow = window.open('https://sharetv.com/shows/' + mapping_value);
            } else if (source === 'simkl_id') {
                if (contentType === 'movie' || contentType === 'Movie') {
                    const newWindow = window.open('https://simkl.com/movies/' + mapping_value);
                } else {
                    const newWindow = window.open('https://simkl.com/tv/' + mapping_value);
                }
            } else if (source === 'trakt_tv_id') {
                if (contentType === 'movie' || contentType === 'Movie') {
                    const newWindow = window.open('https://trakt.tv/movies/' + mapping_value);
                } else {
                    const newWindow = window.open('https://trakt.tv/shows/' + mapping_value);
                }
            } else if (source === 'unogs_id') {
                const newWindow = window.open('https://unogs.com/title/' + mapping_value);
            } else if (source === 'viu_id') {

                    const newWindow = window.open('https://www.viu.com/ott/no-service/');
            } else if (source === 'wetv_id') {
                const newWindow = window.open('https://wetv.vip/en/play/' + mapping_value);
            } else if (source === 'yidio_id') {
                if (contentType === 'movie' || contentType === 'Movie') {
                    const newWindow = window.open('https://www.yidio.com/movie/' + mapping_value);
                } else {
                    const newWindow = window.open('https://www.yidio.com/show/' + mapping_value);
                }
            } else if (source === 'netflix_id') {

                    const newWindow = window.open('https://www.netflix.com/watch/' + mapping_value);
            } else if (source === 'amazon_prime_id') {
                const newWindow = window.open('https://www.amazon.com/gp/video/detail/' + mapping_value);
            } else if (source === 'hbo_max_id') {
                const newWindow = window.open('https://play.hbomax.com/page/urn:hbo:page:' + mapping_value);
            } else if (source === 'disney_plus_id') {
                const newWindow = window.open('https://www.disneyplus.com/');
            } else if (source === 'hulu_id') {
                const newWindow = window.open('https://www.hulu.com/');
            } else if (source === 'box_office_mojo_id') {
                const newWindow = window.open('https://www.boxofficemojo.com/title/' + mapping_value);
            } else if (source === 'box_office_mojo_rl_id') {
                const newWindow = window.open('https://www.boxofficemojo.com/release/' + mapping_value);
            } else if (source === 'viaf_id') {
                const newWindow = window.open('https://viaf.org/viaf/'  + mapping_value);
            } else if (source === 'freebase_id') {
                const newWindow = window.open('https://developers.google.com/');
            } else if (source === 'omdb_person_id') {
                const newWindow = window.open('http://www.omdbapi.com/?t='  + mapping_value);
            } else if (source === 'google_knowledge_graph_id') {
                const newWindow = window.open('https://developers.google.com/knowledge-graph');
            } else if (source === 'eidr_id') {
                const newWindow = window.open('https://ui.eidr.org/view/content?id=' + mapping_value);
            } else if (source === 'instagram_id') {
                const newWindow = window.open('https://www.instagram.com/' + mapping_value);
            } else if (source === 'facebook_id') {
                const newWindow = window.open('https://www.facebook.com/' + mapping_value);
            } else if (source === 'twitter_id') {
                const newWindow = window.open('https://www.twitter.com/' + mapping_value);
            }

        }



    }

    reorderedList($event: any) {
        this.updateMetadata('metadata.data.occupation', this.selectedShow.metadata.data.occupation, 'occupation');
    }

    reorderedProductionCompaniesList($event: any) {
        this.updateMetadata('metadata.data.production_company', this.selectedShow.metadata.data.production_company, 'production_company');
    }

    reorderedDistributionCompaniesList($event: any) {
        this.updateMetadata('metadata.data.distribution_company', this.selectedShow.metadata.data.distribution_company, 'distribution_company');
    }

    reorderedFranchisesList($event: any, geneValue) {
        let franchiseObj;
        if ( geneValue === 'others' ) {
            franchiseObj = this.selectedShow.metadata.data.franchises.others;
        } else if ( geneValue === 'characters' ) {
            franchiseObj = this.selectedShow.metadata.data.franchises.characters;
        } else {
            franchiseObj = this.selectedShow.metadata.data.franchises.universes;
        }
        this.updateMetadata('metadata.data.franchises.' + geneValue, franchiseObj, geneValue);
    }

    private getOrderedItems(values) {
        const result = [];
        for (const item of values) {
            result.push(item.value);
        }
        console.log(result);
        return result;

    }

    private getProductionBudget(value) {
        if (value) {
            return value.amount + ' ' + value.currency;
        }
        return undefined;
    }

    viewWiki(value: string) {
        const newWindow = window.open('https://parrotanalytics.atlassian.net/wiki/spaces/CS/pages/2293923893/Helpdesk+External+Mappings#' + value);
    }

    addItemsToList(items) {
        items = items || [];
        items.push('');
        return items;

    }

    private getUSContentRatings(values) {
        let contentRating = undefined;
        try {
            if (values) {
                contentRating = values.find(value => (value.country_code === 'US' && this.mpaaContentRatings.includes(value.rating)));
            }
        } catch (e) {
            console.error('Exception when trying to get US Content ratings' + e);
        }
        return contentRating || {};
    }

    private getUCANOpeningWeekendTheatreCount(values) {
        let theatreCount = undefined;
        try {
            if (values && values.opening_weekends) {
                theatreCount = values.opening_weekends.find(value => (value.region === 'UCAN' && value.widest_theatre_count));
            }
        } catch (e) {
            console.error('Exception when trying to get UCAN Theatre Count' + e);
        }
        return theatreCount ? theatreCount.widest_theatre_count : '';
    }

    private getPrimaryReleaseType(values) {
        let releaseType = undefined;
        try {
            if (values && values.primary) {
                releaseType = values.primary[0];
            }
        } catch (e) {
            console.error('Exception when trying to get releaseType' + e);
        }
        return releaseType || {};
    }

    onVerificationKeyUp(parrotId, verificationStatus, contentType, imdbId) {

        if ('REPORT_DUPLICATE' !== verificationStatus) {
            this.updateStatus(parrotId, verificationStatus, contentType, imdbId, this.userInputText);
        } else {
            this.showTextarea = true;
        }
    }

    sendReportDuplicate(parrotId, verificationStatus, contentType, imdbId) {
        this.updateStatus(parrotId, verificationStatus, contentType, imdbId, this.userInputText);
        this.userInputText = '';
        this.showTextarea = false;
    }

    private updateStatus(parrotId, verificationStatus, contentType, imdbId, userInputText: string) {
        this.dataLoaded = false;

        this.catalogService.updateVerificationStatus(parrotId, verificationStatus, contentType, imdbId, userInputText).then(res => {
            if (res && res.message.toLowerCase() === 'Successfully updated verification status'.toLowerCase()) {

                this.toasterService.pop('info', 'Successfully Updated the Verification Status');
                if ('HUMAN_VERIFIED' !== verificationStatus) {
                    this.hideDetails();
                    this.dataLoaded = true;
                }
                this.showDetails(this.selectedShow);
                this.dataLoaded = true;
            } else {
                this.toasterService.pop('error', 'Failed to update the verification status');
                this.dataLoaded = true;
            }
        }).catch(error => {
            this.toasterService.pop('error', 'Failed to update the verification status');
            this.dataLoaded = true;
        });
    }

    isAuthorizedUser() {
        const jwt = localStorage.getItem('id_token');
        if (jwt) {
            const decodedJwt = this.jwtHelper.decodeToken(jwt);
            const user = decodedJwt['pun'];
            return user.includes('parrotanalytics.com');
        }
        return false;
    }

    getGenresRaw(show, seriesGenresRawMetadata: any) {

        try {
            const genresRawData = seriesGenresRawMetadata.hits.hits[0]._source;

            if (genresRawData && genresRawData.data) {
                show.metadata.data.genres_d360 = genresRawData.data.genres || [];
                let genresRaw = genresRawData.data.genres_raw || [];

                genresRaw = genresRaw.sort((a, b) => b.score - a.score);

                show.metadata.data.genres_raw = genresRaw.map(item => `${item.value} [${item.score}]`);
            }
        } catch (ex) {
            console.error(ex);
            show.metadata.data.genres_d360 = [];
            show.metadata.data.genres_raw = [];
        }

    }

    getTitleDetails(titlesResponse: any, isTalent) {
        let pidMap;
        if (!isTalent) {
             pidMap = new Map<string, { display_name: string; release_year: string; type: string }>();
        } else {
             pidMap = new Map<string, { display_name: string; date_of_birth: string; type: string }>();
        }

        try {
            const titleHits = titlesResponse.hits;

            if (titleHits) {
                if (!isTalent) {
                    titleHits.hits.forEach((hit) => {
                        const {parrot_id, display_name} = hit._source;
                        const {release_year, type} = hit._source.data;

                        pidMap.set(parrot_id, {display_name, release_year, type});
                    });
                } else {
                    titleHits.hits.forEach((hit) => {
                        const {parrot_id, display_name} = hit._source;
                        const {date_of_birth, type} = hit._source.data;

                        pidMap.set(parrot_id, {display_name, date_of_birth, type});
                    });
                }
            }
        } catch (ex) {
            console.error(ex);
        }
        return pidMap;

    }

    async getCredits(show, creditsResponse, contentType) {
        try {
            const creditsData = creditsResponse.credits;

            if (creditsData) {
                if (contentType === 'TALENT') {
                    await this.processTalentCredits(show, creditsData);
                } else {
                    await this.processCastAndCrewCredits(show, creditsData);
                }
            }
        } catch (ex) {
            console.error(ex);
            show.metadata.data.all_work_credits = [];
            show.metadata.data.all_cast_members = [];
            show.metadata.data.all_crew_members = [];
        }
    }

    async processTalentCredits(show, creditsData) {
        if (creditsData.workCredits && creditsData.workCredits.length > 0) {
            const formattedWorkCredits = await this.formatWorkCredits(creditsData.workCredits);
            await this.updateTitleDetails(show, formattedWorkCredits, 'series_metadata', 'release_year');
            await this.updateTitleDetails(show, formattedWorkCredits, 'movie_metadata', 'release_year');

            formattedWorkCredits.sort((a, b) => {
                if (a.release_year === null && b.release_year !== null) {
                    return 1;
                } else if (a.release_year !== null && b.release_year === null) {
                    return -1;
                } else if (a.release_year === null && b.release_year === null) {
                    return 0;
                } else {
                    return b.release_year - a.release_year;
                }
            });
            show.metadata.data.all_work_credits = formattedWorkCredits;
        }
    }

    async processCastAndCrewCredits(show, creditsData) {
        if (creditsData.additionalInfo) {
            const { castMembers, crewMembers } = creditsData.additionalInfo;
            if (castMembers) {
                const formattedAllMembersMembers = await this.formatMembers(castMembers, true);
                await this.updateTitleDetails(show, formattedAllMembersMembers, 'talent_metadata', 'date_of_birth');

                formattedAllMembersMembers.sort((a, b) => {
                    if (a.display_name === null && b.display_name !== null) {
                        return 1;
                    } else if (a.display_name !== null && b.display_name === null) {
                        return -1;
                    } else if (a.display_name === null && b.display_name === null) {
                        return 0;
                    } else {
                        return a.display_name.localeCompare(b.display_name);
                    }
                });

                show.metadata.data.all_cast_members = formattedAllMembersMembers;
            }
            if (crewMembers) {
                const formattedAllMembers = await this.formatMembers(crewMembers, false);
                await this.updateTitleDetails(show, formattedAllMembers, 'talent_metadata', 'date_of_birth');

                formattedAllMembers.sort((a, b) => {
                    if (a.display_name === null && b.display_name !== null) {
                        return 1;
                    } else if (a.display_name !== null && b.display_name === null) {
                        return -1;
                    } else if (a.display_name === null && b.display_name === null) {
                        return 0;
                    } else {
                        return a.display_name.localeCompare(b.display_name);
                    }
                });

                show.metadata.data.all_crew_members = formattedAllMembers;
            }
        }
    }

    async formatWorkCredits(credits) {

        return credits.map((credit) => {
            let roles = null;
            if (credit.professions) {
                roles = Array.from(
                    new Set(
                        credit.professions.map((role) => role.string)
                    )
                ).join(', ');
            }
            const parrotId = credit.parrotId ? credit.parrotId.string : null;
            const contentType = credit.contentType ? credit.contentType.string : null;

            return {
                parrot_id: parrotId,
                content_type: contentType,
                profession: roles,
                release_year: null,
                display_name: null
            };
        });
    }

    async formatMembers(members, isCastData) {
        return members.map((credit) => {
            let roles = null;
            let characters = null;
            if (isCastData && credit.roles) {
                characters = Array.from(
                    new Set(
                        credit.roles
                            .map((role) => role.character ? role.character.string : null)
                            .filter((character) => character !== null)
                    )
                ).join(', ');
            }
                roles = Array.from(
                    new Set(
                        credit.roles
                            .map((role) => role.roleType ? role.roleType.string : null)
                            .filter((roleType) => roleType !== null)
                    )
                ).join(', ');
            const parrotId = credit.parrotId ? credit.parrotId.string : null;
            const contentType = credit.contentType ? credit.contentType.string : null;

            return {
                parrot_id: parrotId,
                content_type: contentType,
                roles: roles,
                characters: characters,
                birth_date: null,
                display_name: null
            };
        });
    }

    async updateTitleDetails(show, formattedCredits, metadataType, dateField) {
        const distinctPidsSet = new Set<string>();
        formattedCredits.forEach((credit) => {
            distinctPidsSet.add(credit.parrot_id);
        });
        const esQueryString = {
            'query': {
                'bool': {
                    'must': [
                        {
                            'terms': {
                                'parrot_id': Array.from(distinctPidsSet)
                            }
                        }
                    ]
                }
            },
            '_source': ['parrot_id', 'display_name', 'data.type', 'data.' + dateField], 'size': 10000 // Update the source fields accordingly
        };

        const query = esQueryString;
        const seriesGenresRawQuery = JSON.stringify(query);
        const titleDetailsResponse = await this.catalogService.callEsProxyLoadMetaData(seriesGenresRawQuery, metadataType);
        const titleDetails = this.getTitleDetails(titleDetailsResponse, metadataType === 'talent_metadata');

        formattedCredits.forEach((credit) => {
            const { parrot_id } = credit;
            if (titleDetails.has(parrot_id) && metadataType !== 'talent_metadata') {
                const { display_name, release_year } = titleDetails.get(parrot_id)!;
                credit.release_year = release_year;
                credit.display_name = display_name;
            } else if (titleDetails.has(parrot_id) && metadataType === 'talent_metadata') {
                const { display_name, date_of_birth } = titleDetails.get(parrot_id)!;
                credit.birth_date = date_of_birth;
                credit.display_name = display_name;
            }
        });
    }


    copyMessage(val: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    handleImageError(event: any) {
        event.target.src = '/assets/img/placeholders/poster-placeholder.jpg';
    }

    filteredWorkCreditsMembers(): any[] {
        if (this.selectedShow && this.selectedShow.metadata && this.selectedShow.metadata.data) {
            const allCastMembers = this.selectedShow.metadata.data.all_cast_members;
            if (this.selectedRole === 'All') {
                return allCastMembers || [];
            } else {
                return (allCastMembers || []).filter((cast: any) => {
                    if (cast.roles && typeof cast.roles === 'string') {
                        const castRoles = cast.roles.split(',').map((role: string) => role.trim());
                        return castRoles.includes(this.selectedRole);
                    }
                    return false;
                });
            }
        }
        return [];
    }

    filteredWorkCredits(): any[] {
        if (this.selectedShow && this.selectedShow.metadata && this.selectedShow.metadata.data) {
            const allWorkCredits = this.selectedShow.metadata.data.all_work_credits;
            if (this.selectedWorkCreditContentType === 'All' && this.selectedWorkCreditRole === 'All') {
                return allWorkCredits || [];
            } else {
                return (allWorkCredits || []).filter((cast: any) => {
                    const contentTypeCondition = this.selectedWorkCreditContentType === 'All' || cast.content_type === this.selectedWorkCreditContentType;
                    const workCreditCondition = this.selectedWorkCreditRole === 'All' || this.filterByRole(cast);
                    return contentTypeCondition && workCreditCondition;
                });
            }
        }
    }
    filterByRole(cast) {
        if (cast.profession && typeof cast.profession === 'string') {
            const castRoles = cast.profession.split(',').map((role: string) => role.trim());
            return castRoles.includes(this.selectedWorkCreditRole);
        }
        return false;
    }


    filteredCastMembers(): any[] {
        if (this.selectedShow && this.selectedShow.metadata && this.selectedShow.metadata.data) {
            const allCastMembers = this.selectedShow.metadata.data.all_cast_members;
            if (this.selectedRole === 'All') {
                return allCastMembers || [];
            } else {
                return (allCastMembers || []).filter((cast: any) => {
                    if (cast.roles && typeof cast.roles === 'string') {
                        const castRoles = cast.roles.split(',').map((role: string) => role.trim());
                        return castRoles.includes(this.selectedRole);
                    }
                    return false;
                });
            }
        }
        return [];
    }

    filteredCrewMembers(): any[] {
        if (this.selectedShow && this.selectedShow.metadata && this.selectedShow.metadata.data) {
            const allCrewMembers = this.selectedShow.metadata.data.all_crew_members;
            if (this.selectedCrewRole === 'All') {
                return allCrewMembers || [];
            } else {
                return (allCrewMembers || []).filter((cast: any) => {
                    if (cast.roles && typeof cast.roles === 'string') {
                        const castRoles = cast.roles.split(',').map((role: string) => role.trim());
                        return castRoles.includes(this.selectedCrewRole);
                    }
                    return false;
                });
            }
        }
        return [];
    }
}



// WEBPACK FOOTER //
// ./src/app/catalogue/catalog-manage/catalog-manage.component.ts